import { motion, AnimatePresence } from 'framer-motion';

interface WhatsNewBadgeProps {
  show: boolean;
  className?: string;
}

export const WhatsNewBadge = ({ show, className = '' }: WhatsNewBadgeProps) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.span
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 500, damping: 25 }}
          className={`absolute -top-1 -right-1 w-2.5 h-2.5 bg-primary rounded-full ${className}`}
        >
          <span className="absolute inset-0 rounded-full bg-primary animate-ping opacity-75" />
        </motion.span>
      )}
    </AnimatePresence>
  );
};

export default WhatsNewBadge;
